import { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { Modal } from 'react-bootstrap';

import moment from 'moment-timezone';

import { Requirement } from '../../classess/requirement/requirement';
import {
    badgetStatusGeneric, getProcessButtons, setDateTimeFormatGlobal, setDateTimeFormatGlobalString, isUndNullEmp, isValidDate, getLanguageObj, lodash,
    getResponse, getRolesType, handleResponseMessageAsync, settings, styles
} from '../../helpers/main';
import { User } from '../../classess/user/user';
import { UserCompanyCustomer } from '../../classess/userCompanyCustomer/userCompanyCustomer';
import { Customer } from '../../classess/customer/customer';
import { GlobalFormats } from '../../classess/main/globalFormats';
import { Status } from '../../classess/status/status';
import { RequirementService } from '../../services/requirements/RequirementService';

const { icons, images, labels, messages, } = settings;

const currentMethod = 'RequirementAdd';

export default function RequirementAdd({
    modalObj = {
        $: {},
        type: 0,
        auth: {},
        showModal: false,
        languageObj: GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
        dtRequirementsId: '',
        dtRequirementsRowId: 0,
        requirement: Requirement.getClass({}, false),
        users: [User?.getClass({}, false)],
        analysts: [User?.getClass({}, false)],
        userCustomers: [User?.getClass({}, false)],
        customers: [Customer?.getClass({}, false)],
        userCompanyCustomers: [UserCompanyCustomer?.getClass({}, false)],
        userRoles: getRolesType(),
    },
    setModalObj = {},
}) {
    //#region variables
    const isMount = useRef(false);
    const [process, setProcess] = useState({
        showLoading: false,
        save: false,
        back: false,
        selUserCustomerDisabled: true,
        selAnalystDisabled: true,
        selUserDisabled: true,
    });
    const [errors, setErrors] = useState({
        user: '',
        customer: '',
        analyst: '',
        registerDate: '',
        visitDate: '',
        authorizedBy: '',
        contactPerson: '',
        department: '',
        commentary: '',
        informCreationUser: '',
    });

    const [dataFormLength] = useState(Requirement.minMaxLength(false));
    const [userCustomers, setUserCustomers] = useState([User?.getClass({}, false)]);
    const [analysts, setAnalysts] = useState([User?.getClass({}, false)]);
    const [customers, setCustomers] = useState([Customer?.getClass({}, false)]);
    const [users, setUsers] = useState([User?.getClass({}, false)]);

    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnModalBack',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnModalSave',
            },
            closeModal: {
                defaultClass: 'close border-0 bg-transparent',
                id: 'btnModalClose',
            },
        },
        checkBoxs: {
            informCreation: {
                id: 'chkModalInformCreation',
                defaultClass: '',
            }
        },
        icons: {
            save: {
                id: 'iconModalSave',
                defaultClass: icons?.fasFa?.save,
            },
            back: {
                id: 'iconModalBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            authorizedBy: {
                id: 'inputModalAuthorizedBy',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            contactPerson: {
                id: 'inputModalContactPerson',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            department: {
                id: 'inputModalDepartment',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            userRegisterDate: {
                id: 'inputModalUserRegisterDate',
                defaultClass: 'form-control datetimepicker-input bg-light border-0 shadow-sm text-dark',
            },
            visitDate: {
                id: 'inputModalVisitDate',
                defaultClass: 'form-control datetimepicker-input bg-light border-0 shadow-sm text-dark',
            },
        },
        pickers: {
            userRegisterDate: {
                id: 'pkModalRegisterDate',
            },
            visitDate: {
                id: 'pkModalVisitDate',
            },
        },
        selects: {
            analysts: {
                id: 'selModalAnalyst',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
            customers: {
                id: 'selModalCustomer',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
            userCustomer: {
                id: 'selModalUserCustomer',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
            informCreationUser: {
                id: 'selModalInformCreationUser',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
        },
        spiners: {
            save: {
                id: 'spModalSave',
                defaultClass: 'spinner-border spinner-border-sm',
            }
        },
        textAreas: {
            commentary: {
                id: 'txtAreaModalCommentary',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            }
        }
    };
    //#endregion variables

    //#region methods
    //#region customers
    const setUserCustomersFunc = async ({
        e = undefined,
        id = '',
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setUserCustomersFunc';
        try {
            const userId = id;
            let customersData = [];

            if (!isUndNullEmp({ data: id, subMethod: currentMethod })?.result) {
                const userCompanyCustomersData = modalObj?.userCompanyCustomers.filter((ucc) => ucc.userId === userId) || [];

                if (!isUndNullEmp({ data: userCompanyCustomersData, subMethod: currentMethod })?.result) {
                    const uniqueResponse = lodash.unique({ data: userCompanyCustomersData, key: 'customerId', subMethod: currentMethod });
                    if (!uniqueResponse?.isSuccess || uniqueResponse?.isWarning) return;

                    const userCompanyCustomersByIdData = uniqueResponse?.result || [];
                    userCompanyCustomersByIdData.forEach((detail) => {
                        const customer = modalObj?.customers.find((c) => c.id === detail.customerId);
                        if (customer) customersData.push(customer);
                    });
                }
            }

            setCustomers(customersData);
            setModalObj(prev => ({
                ...prev,
                requirement: {
                    ...prev?.requirement,
                    userId: userId,
                }
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!response?.isSuccess || response?.isWarning || response?.msgText || response?.msgTextHtml) {
                await handleResponseMessageAsync({
                    response: response,
                    currentMethod: currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id,
                });
            }
        }
    }
    //#endregion customers

    //#region requirements
    const addRequirement = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'addRequirement';
        try {
            e?.preventDefault?.();

            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            const requirementSetData = response?.result?.requirement || modalObj?.requirement;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, save: true }));

            //#region create requirement
            response = await RequirementService.create({
                auth: modalObj?.auth,
                data: requirementSetData,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion create requirement

            const createdRequirement = response?.result?.requirement || {};
            const status = response?.result?.status || [];

            //#region datatable add
            const modelRequirement = Requirement.getClass(createdRequirement, false);
            const modelStatus = Status?.getClass(status.find(({ id }) => id === modelRequirement?.statusId) || {}, false);
            const statusLabel = !isUndNullEmp({ data: modelStatus?.label, subMethod: currentMethod }) ?
                modelStatus.label :
                `${modelStatus?.name.replace(' ', '').charAt(0).toLowerCase()}${modelStatus?.name.replace(' ', '').slice(1)}`;

            modalObj.$(`#${modalObj.dtRequirementsId}`).DataTable().row.add([
                `<b>${modelRequirement.id}</b>`,
                badgetStatusGeneric({
                    type: (modelRequirement?.statusId || 5) === 4 ?
                        0 : (modelRequirement?.statusId || 5) === 5 ?
                            -1 : (modelRequirement?.statusId || 5),
                    value: labels[statusLabel][modalObj?.languageObj?.id]
                }),
                setDateTimeFormatGlobal({
                    date: modelRequirement.visitDate,
                    type: modalObj?.languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    withSeconds: false,
                    subMethod: currentMethod,
                })?.result,
                modelRequirement.contactPerson,
                getProcessButtons({
                    id: modelRequirement.id,
                    description: modelRequirement.id,
                    showDetails: true,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: true,
                    showDelete: modalObj?.userRoles?.isAdmin,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: modalObj?.userRoles?.isAdmin,
                    showEdit: modalObj?.userRoles?.isAdmin,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: modalObj?.userRoles?.isAdmin,
                    processButtons: [],
                })?.result,
            ])?.draw(true);
            //#endregion datatable add

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ closeModal: true, subMethod: currentMethod });
            }

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id,
                });
            }
        }
    }
    //#endregion requirements

    //#region others
    const getData = async ({
        subMethod = ''
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region set data
            if (modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst) {
                setCustomers([]);
            } else {
                setCustomers(modalObj?.customers || []);
            }
            setUsers(modalObj?.users);
            setAnalysts(modalObj?.analysts || []);
            setUserCustomers(modalObj?.userCustomers || []);
            //#endregion set data

            //#region set disables
            setProcess(prev => ({
                ...prev,
                selUserDisabled: !(modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst),
                selAnalystDisabled: !(modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst),
                selUserCustomerDisabled: !(modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst),
            }));
            //#endregion set disables

            //#region set data input timers
            response = setDateInControl({
                date: new Date().toISOString(),
                userRegisterDate: modalObj?.requirement?.userRegisterDate,
                visitDate: modalObj?.requirement?.visitDate,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion set data input timers

            //#region checkbox set data
            // if (!isUndNullEmp({ data: modalObj?.requirement?.informCreation, subMethod: currentMethod, })?.result) {
            //     modalObj?.$(`#${controls?.checkBoxs?.informCreation?.id}`).attr('checked', modalObj?.requirement?.informCreation);
            // }
            //#endregion checkbox set data
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText || response?.msgTextHtml) {
                await handleResponseMessageAsync({
                    response: response,
                    currentMethod: currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id,
                });
            }
        }
    }

    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    showModal: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.error(response?.msgText);
        }
    }

    const validateFormData = ({
        subMethod = ''
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'validateFormData';
        try {
            const userRegisterDate = modalObj?.$(`#${controls?.inputs?.userRegisterDate?.id}`).val();
            const visitDate = modalObj?.$(`#${controls?.inputs?.visitDate.id}`).val();
            const thisFieldRequired = `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`;

            const newErrors = { ...errors };
            let hasErrors = false;

            if (isUndNullEmp({ data: modalObj?.requirement?.userId, subMethod: currentMethod })?.result) {
                newErrors.user = thisFieldRequired
                hasErrors = true;
            }

            if (isUndNullEmp({ data: modalObj?.requirement?.customerId, subMethod: currentMethod })?.result ||
                parseInt(modalObj?.requirement?.customerId) <= 0) {
                newErrors.customer = thisFieldRequired
                hasErrors = true;
            }

            if (isUndNullEmp({ data: modalObj?.requirement?.analystId, subMethod: currentMethod })?.result) {
                newErrors.analyst = thisFieldRequired
                hasErrors = true;
            }

            if (isUndNullEmp({ data: userRegisterDate, subMethod: currentMethod })?.result) {
                newErrors.registerDate = thisFieldRequired
                hasErrors = true;
            } else if (!isValidDate({ data: userRegisterDate, subMethod: currentMethod })?.result) {
                newErrors.registerDate = thisFieldRequired
                hasErrors = true;
            }

            if (isUndNullEmp({ data: visitDate, subMethod: currentMethod })?.result) {
                newErrors.visitDate = thisFieldRequired
                hasErrors = true;
            } else if (!isValidDate({ data: visitDate, subMethod: currentMethod })?.result) {
                newErrors.visitDate = thisFieldRequired
                hasErrors = true;
            }

            if (isUndNullEmp({ data: modalObj?.requirement?.authorizedBy, subMethod: currentMethod })?.result) {
                newErrors.authorizedBy = thisFieldRequired
                hasErrors = true;
            }

            if (isUndNullEmp({ data: modalObj?.requirement?.contactPerson, subMethod: currentMethod })?.result) {
                newErrors.contactPerson = thisFieldRequired
                hasErrors = true;
            }

            if (isUndNullEmp({ data: modalObj?.requirement?.department, subMethod: currentMethod })?.result) {
                newErrors.department = thisFieldRequired
                hasErrors = true;
            }

            if (isUndNullEmp({ data: modalObj?.requirement?.commentary, subMethod: currentMethod })?.result) {
                newErrors.commentary = thisFieldRequired
                hasErrors = true;
            }

            if (isUndNullEmp({ data: modalObj?.requirement?.informCreationUserId, subMethod: currentMethod })?.result) {
                newErrors.informCreationUser = thisFieldRequired
                hasErrors = true;
            }

            if (hasErrors) {
                setErrors(newErrors);
                response = getResponse({ type: 1 });
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = ''
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setErrorsDefault';
        try {
            setErrors({
                user: '',
                customer: '',
                analyst: '',
                registerDate: '',
                visitDate: '',
                authorizedBy: '',
                contactPerson: '',
                department: '',
                commentary: '',
                informCreationUser: '',
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setData = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setData';
        try {
            const userRegisterDate = modalObj.$(`#${controls?.pickers?.userRegisterDate?.id}`)?.datetimepicker('date')?._d;
            const visitDate = modalObj.$(`#${controls?.pickers?.visitDate?.id}`)?.datetimepicker('date')?._d;

            const requirementSetData = {
                ...modalObj?.requirement,
                userRegisterDate: moment(userRegisterDate).format(`${modalObj?.languageObj?.format?.date?.f13}T${modalObj?.languageObj?.format?.time?.f2}.000Z`),
                visitDate: moment(visitDate).format(`${modalObj?.languageObj?.format?.date?.f13}T${modalObj?.languageObj?.format?.time?.f2}.000Z`),
            };

            setModalObj(prev => ({
                ...prev,
                requirement: requirementSetData
            }));

            response.result = { requirement: requirementSetData };
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDateInControl = ({
        date = undefined,
        userRegisterDate = undefined,
        visitDate = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDateInControl';
        try {
            //#region variables
            let userRegisterDateVal = '';
            let visitDateVal = '';
            const tf = modalObj?.languageObj?.format?.time?.type;
            const dtf = `${modalObj?.languageObj?.format?.date?.f11} ${modalObj?.languageObj?.format?.time?.picker?.hhmm}`;
            const df = modalObj?.languageObj?.format?.date?.f1;
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: userRegisterDate, subMethod: currentMethod })?.result) {
                userRegisterDateVal = setDateTimeFormatGlobalString({ date: userRegisterDate, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod })?.result) {
                userRegisterDateVal = setDateTimeFormatGlobalString({ date: date, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            }

            if (!isUndNullEmp({ data: visitDate, subMethod: currentMethod })?.result) {
                visitDateVal = setDateTimeFormatGlobalString({ date: visitDate, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod })?.result) {
                visitDateVal = setDateTimeFormatGlobalString({ date: date, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            }

            modalObj.$.fn.datetimepicker.Constructor.Default = modalObj.$.extend({}, modalObj.$.fn.datetimepicker.Constructor.Default, {
                icons: settings?.react?.tempusDominus?.icons,
                buttons: settings?.react?.tempusDominus?.buttons,
                tooltips: settings?.react?.tempusDominus?.tooltips({ languageId: modalObj?.languageObj?.id }),
                locale: modalObj?.languageObj?.id,
            });

            modalObj.$(`#${controls?.pickers?.userRegisterDate?.id}`)?.datetimepicker(
                'options',
                {
                    date: userRegisterDateVal,
                    default: false,
                    timepicker: true,
                    format: dtf,
                }
            );

            modalObj.$(`#${controls?.pickers?.visitDate?.id}`)?.datetimepicker(
                'options',
                {
                    date: visitDateVal,
                    default: false,
                    timepicker: true,
                    format: dtf,
                }
            );
            //#endregion methods
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <Modal backdrop='static' show={modalObj?.showModal} centered>
            <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                <Modal.Title className='d-flex align-items-center w-100'>
                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img alt='requirements' src={images?.icons?.requirements} style={{ ...styles?.cardHeaderLogo }} />
                    </div>
                    <div className='d-flex flex-column'>
                        <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.requirement?.[modalObj?.languageObj?.id]}</span>
                        <div className='d-flex align-items-center mt-1'>
                            <span className={`badge badge-pill py-1 px-2 text-uppercase ${modalObj?.type === 0 ? 'badge-info' : modalObj?.type === 1 ? 'badge-warning text-dark' : 'badge-secondary'}`} style={settings?.html?.badges?.micro}>
                                {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] :
                                    modalObj?.type === 1 ? labels?.edit?.[modalObj?.languageObj?.id] :
                                        labels?.detail?.[modalObj?.languageObj?.id]}
                            </span>
                        </div>
                    </div>
                </Modal.Title>
                <button id={controls?.buttons?.closeModal?.id}
                    device='button'
                    className={controls?.buttons?.closeModal?.defaultClass}
                    data-dismiss='modal'
                    aria-label='Close'
                    disabled={process?.save}
                    style={{ fontSize: '1.5rem', marginTop: '-15px' }}
                    onClick={() => setDefaultValue({ closeModal: true, subMethod: 'headerCloseButton' })}>
                    <span aria-hidden='true'>&times;</span>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => modalObj?.type !== 2 ? addRequirement({ e: e, subMethod: 'formModal - onSubmit' }) : e.preventDefault()}>
                <Modal.Body className='p-0'>
                    <div className='card-body p-4'>
                        {modalObj?.type !== 2 ? (
                            <div className='row'>
                                <div className='col-md-12 mb-3'>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.user} /> {labels?.user?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <select id={controls?.selects?.userCustomer?.id}
                                            disabled={process?.selUserCustomerDisabled || process?.save}
                                            className={controls?.selects?.userCustomer?.defaultClass}
                                            style={{ borderRadius: '5px' }}
                                            value={!isUndNullEmp({ data: modalObj?.requirement?.userId, subMethod: controls?.selects?.userCustomer?.id, })?.result ?
                                                modalObj?.requirement?.userId : ``
                                            }
                                            onChange={(e) => setUserCustomersFunc({ e: e, id: e?.target?.value, subMethod: controls?.selects?.userCustomer?.id, })}
                                            onFocus={() => setErrors(prev => ({ ...prev, user: '' }))}
                                            placeholder={labels?.user?.[modalObj?.languageObj?.id]}
                                            title={labels?.user?.[modalObj?.languageObj?.id]}>
                                            <option key={`nothing`} value={``}>{messages?.selectUser?.[modalObj?.languageObj?.id]}</option>
                                            {userCustomers.map((user) => <option key={user.id} value={user.id}>{user.firstName}, {user.lastName}</option>)}
                                        </select>
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.user)}</div>
                                    </div>
                                </div>

                                <div className='col-md-12 mb-3'>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.building} /> {labels?.customer?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <select id={controls?.selects?.customers.id}
                                            className={controls?.selects?.customers.defaultClass}
                                            style={{ borderRadius: '5px' }}
                                            disabled={process?.save}
                                            value={!isUndNullEmp({ data: modalObj?.requirement?.customerId, subMethod: controls?.selects?.customers.id, })?.result ?
                                                modalObj?.requirement?.customerId : ``
                                            }
                                            onChange={(e) => setModalObj(prev => ({
                                                ...prev,
                                                requirement: { ...prev?.requirement, customerId: parseInt(e?.target?.value) },
                                            }))}
                                            onFocus={() => setErrors(prev => ({ ...prev, customer: '', }))}
                                            placeholder={labels?.customer?.[modalObj?.languageObj?.id]}
                                            title={labels?.customer?.[modalObj?.languageObj?.id]}>
                                            <option key={`nothing`} value={`0`}>{messages?.selectCustomer?.[modalObj?.languageObj?.id]}</option>
                                            {customers.map((customer) => <option key={customer.id} value={customer.id}>{customer.name}</option>)}
                                        </select>
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.customer)}</div>
                                    </div>
                                </div>

                                <div className='col-md-12 mb-3' hidden={!(modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst)}>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.userTie} /> {labels?.analyst?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <select id={controls?.selects?.analysts?.id}
                                            disabled={process?.selAnalystDisabled || process?.save}
                                            className={controls?.selects?.analysts?.defaultClass}
                                            style={{ borderRadius: '5px' }}
                                            value={!isUndNullEmp({ data: modalObj?.requirement?.analystId, subMethod: controls?.selects?.analysts?.id, })?.result ?
                                                modalObj?.requirement?.analystId : ``
                                            }
                                            onChange={(e) => setModalObj(prev => ({
                                                ...prev,
                                                requirement: { ...prev?.requirement, analystId: e?.target?.value },
                                            }))}
                                            onFocus={() => setErrors(prev => ({ ...prev, analyst: '' }))}
                                            placeholder={labels?.analyst?.[modalObj?.languageObj?.id]}
                                            title={labels?.analyst?.[modalObj?.languageObj?.id]}>
                                            <option key={`nothing`} value={``}>{messages?.selectAnalyst?.[modalObj?.languageObj?.id]}</option>
                                            {analysts.map((analyst) => <option key={analyst.id} value={analyst.id}>{analyst?.firstName}, {analyst?.lastName}</option>)}
                                        </select>
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.analyst)}</div>
                                    </div>
                                </div>

                                <div className='col-md-6 mb-3' hidden={!modalObj?.userRoles?.isAdmin}>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.faFa?.calendarAlt} /> {labels?.registerDate?.[modalObj?.languageObj?.id]}
                                        </small>
                                        {!isUndNullEmp({ data: modalObj?.requirement?.userRegisterDate, subMethod: controls?.inputs?.userRegisterDate?.id, })?.result && (
                                            <div id={controls?.pickers?.userRegisterDate?.id} className='input-group date' data-target-input='nearest'>
                                                <input id={controls?.inputs?.userRegisterDate?.id}
                                                    className={controls?.inputs?.userRegisterDate?.defaultClass}
                                                    style={{ borderRadius: '5px' }}
                                                    disabled={process?.save}
                                                    data-target={`#${controls?.pickers?.userRegisterDate?.id}`}
                                                    data-toggle='datetimepicker'
                                                    onFocus={() => setErrors(prev => ({ ...prev, registerDate: '' }))}
                                                    placeholder={labels?.registerDate?.[modalObj?.languageObj?.id]}
                                                    title={labels?.registerDate?.[modalObj?.languageObj?.id]}
                                                    type='text' />
                                                <div className='input-group-append' data-target={`#${controls?.pickers?.userRegisterDate?.id}`} data-toggle='datetimepicker'>
                                                    <div className='input-group-text bg-secondary border-0'><i className={icons?.faFa?.calendarAlt} /></div>
                                                </div>
                                            </div>
                                        )}
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.registerDate)}</div>
                                    </div>
                                </div>

                                <div className='col-md-6 mb-3'>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.faFa?.calendarAlt} /> {labels?.visitDate?.[modalObj?.languageObj?.id]}
                                        </small>
                                        {!isUndNullEmp({ data: modalObj?.requirement?.visitDate, subMethod: controls?.inputs?.visitDate.id, })?.result && (
                                            <div id={controls?.pickers?.visitDate?.id} className='input-group date' data-target-input='nearest'>
                                                <input id={controls?.inputs?.visitDate.id}
                                                    className={controls?.inputs?.visitDate.defaultClass}
                                                    style={{ borderRadius: '5px' }}
                                                    disabled={process?.save}
                                                    data-target={`#${controls?.pickers?.visitDate?.id}`}
                                                    data-toggle='datetimepicker'
                                                    onFocus={() => setErrors(prev => ({ ...prev, visitDate: '', }))}
                                                    placeholder={labels?.visitDate?.[modalObj?.languageObj?.id]}
                                                    title={labels?.visitDate?.[modalObj?.languageObj?.id]}
                                                    type='text' />
                                                <div className='input-group-append' data-target={`#${controls?.pickers?.visitDate?.id}`} data-toggle='datetimepicker'>
                                                    <div className='input-group-text bg-secondary border-0'><i className={icons?.faFa?.calendarAlt} /></div>
                                                </div>
                                            </div>
                                        )}
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.visitDate)}</div>
                                    </div>
                                </div>

                                <div className='col-md-6 mb-3'>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.userShield} /> {labels?.authorizedBy?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <input id={controls?.inputs?.authorizedBy?.id}
                                            className={controls?.inputs?.authorizedBy?.defaultClass}
                                            style={{ borderRadius: '5px' }}
                                            disabled={process?.save}
                                            maxLength={dataFormLength?.max?.authorizedBy}
                                            onChange={(e) => setModalObj(prev => ({
                                                ...prev,
                                                requirement: { ...prev?.requirement, authorizedBy: e?.target?.value }
                                            }))}
                                            onFocus={() => setErrors(prev => ({ ...prev, authorizedBy: '' }))}
                                            value={modalObj?.requirement?.authorizedBy || ''}
                                            placeholder={labels?.authorizedBy?.[modalObj?.languageObj?.id]}
                                            title={labels?.authorizedBy?.[modalObj?.languageObj?.id]} />
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.authorizedBy)}</div>
                                    </div>
                                </div>

                                <div className='col-md-6 mb-3'>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.userTag} /> {labels?.contactPerson?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <input id={controls?.inputs?.contactPerson?.id}
                                            className={controls?.inputs?.contactPerson?.defaultClass}
                                            style={{ borderRadius: '5px' }}
                                            disabled={process?.save}
                                            maxLength={dataFormLength?.max?.contactPerson}
                                            onChange={(e) => setModalObj(prev => ({
                                                ...prev,
                                                requirement: { ...prev?.requirement, contactPerson: e?.target?.value }
                                            }))}
                                            onFocus={() => setErrors(prev => ({ ...prev, contactPerson: '', }))}
                                            value={modalObj?.requirement?.contactPerson || ''}
                                            placeholder={labels?.contactPerson?.[modalObj?.languageObj?.id]}
                                            title={labels?.contactPerson?.[modalObj?.languageObj?.id]} />
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.contactPerson)}</div>
                                    </div>
                                </div>

                                <div className='col-md-12 mb-3'>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.building} /> {labels?.department?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <input id={controls?.inputs?.department?.id}
                                            className={controls?.inputs?.department?.defaultClass}
                                            style={{ borderRadius: '5px' }}
                                            disabled={process?.save}
                                            maxLength={dataFormLength?.max?.department}
                                            onChange={(e) => setModalObj(prev => ({
                                                ...prev,
                                                requirement: { ...prev?.requirement, department: e?.target?.value },
                                            }))}
                                            onFocus={() => setErrors(prev => ({ ...prev, department: '' }))}
                                            value={modalObj?.requirement?.department || ''}
                                            placeholder={labels?.department?.[modalObj?.languageObj?.id]}
                                            title={labels?.department?.[modalObj?.languageObj?.id]} />
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.department)}</div>
                                    </div>
                                </div>

                                <div className='col-md-12 mb-3'>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.edit} /> {labels?.commentary?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <textarea id={controls.textAreas?.commentary?.id}
                                            className={controls.textAreas?.commentary?.defaultClass}
                                            style={{ borderRadius: '5px', minHeight: '100px' }}
                                            disabled={process?.save}
                                            maxLength={dataFormLength?.max?.commentary}
                                            placeholder={labels?.commentary?.[modalObj?.languageObj?.id]}
                                            onChange={(e) => setModalObj(prev => ({
                                                ...prev,
                                                requirement: { ...prev?.requirement, commentary: e?.target?.value },
                                            }))}
                                            onFocus={() => setErrors(prev => ({ ...prev, commentary: '' }))}
                                            value={modalObj?.requirement?.commentary || ''}
                                            rows={3}
                                            title={labels?.commentary?.[modalObj?.languageObj?.id]} />
                                        <div className='form-text' style={styles?.labelMsgAlert}>{parse(errors?.commentary)}</div>
                                    </div>
                                </div>

                                <div className='col-12'>
                                    <hr className='my-4' />
                                </div>

                                {modalObj?.userRoles?.isAdmin && (
                                    <div className='col-md-12 mb-3'>
                                        <div className='form-group'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={icons?.fasFa?.userPlus} /> {labels?.informCreationUser?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <select id={controls?.selects?.informCreationUser?.id}
                                                disabled={process?.selUserDisabled || process?.save}
                                                className={controls?.selects?.informCreationUser?.defaultClass}
                                                style={{ borderRadius: '5px' }}
                                                value={modalObj?.requirement?.informCreationUserId || ''}
                                                onChange={(e) => setModalObj(prev => ({
                                                    ...prev,
                                                    requirement: { ...prev?.requirement, informCreationUserId: e?.target?.value },
                                                }))}
                                                onFocus={() => setErrors(prev => ({ ...prev, informCreationUser: '' }))}
                                                placeholder={labels?.informCreationUser?.[modalObj?.languageObj?.id]}
                                                title={labels?.informCreationUser?.[modalObj?.languageObj?.id]}>
                                                <option key={`nothing`} value={``}>{messages?.selectUser?.[modalObj?.languageObj?.id]}</option>
                                                {users.map((user) => <option key={user.id} value={user.id}>{user.firstName}, {user.lastName}</option>)}
                                            </select>
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.informCreationUser)}</div>
                                        </div>
                                    </div>
                                )}

                                {(modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst) && (
                                    <div className='col-md-12 mb-3'>
                                        <div className='form-group d-flex align-items-center'>
                                            <div className='mr-3'>
                                                <input id={controls?.checkBoxs?.informCreation?.id}
                                                    type='checkbox'
                                                    disabled={process?.save}
                                                    style={{ cursor: process?.save ? 'default' : 'pointer' }}
                                                    data-toggle='toggle'
                                                    data-size='xs'
                                                    data-width={50}
                                                    data-on={labels?.yes?.[modalObj?.languageObj?.id]}
                                                    data-off={labels?.no?.[modalObj?.languageObj?.id]}
                                                    checked={modalObj?.requirement?.informCreation || false}
                                                    onChange={(e) => setModalObj(prev => ({
                                                        ...prev,
                                                        requirement: { ...prev?.requirement, informCreation: e?.target?.checked }
                                                    }))} />
                                            </div>
                                            <small onClick={(e) => {
                                                setModalObj(prev => ({
                                                    ...prev,
                                                    requirement: {
                                                        ...prev?.requirement, informCreation: !prev?.requirement?.informCreation
                                                    }
                                                }))
                                            }}
                                                className='text-muted text-uppercase font-weight-bold'
                                                style={{ cursor: 'pointer' }}>
                                                {labels?.informCreation?.[modalObj?.languageObj?.id]}?
                                            </small>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className='row'>
                                <div className='col-md-12 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.user} /> {labels?.user?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold'>
                                            {(() => {
                                                const user = userCustomers.find(u => u.id === modalObj?.requirement?.userId);
                                                return user ? `${user.firstName}, ${user.lastName}` : '---';
                                            })()}
                                        </span>
                                    </div>
                                </div>
                                <div className='col-md-12 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.building} /> {labels?.customer?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold'>
                                            {(customers.find(c => c.id === modalObj?.requirement?.customerId))?.name || '---'}
                                        </span>
                                    </div>
                                </div>
                                <div className='col-md-12 mb-4' hidden={!(modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst)}>
                                    <div className='p-3 rounded bg-light border-left border-secondary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.userTie} /> {labels?.analyst?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold'>
                                            {(() => {
                                                const analyst = analysts.find(a => a.id === modalObj?.requirement?.analystId);
                                                return analyst ? `${analyst.firstName}, ${analyst.lastName}` : '---';
                                            })()}
                                        </span>
                                    </div>
                                </div>
                                <div className='col-md-6 mb-4' hidden={!modalObj?.userRoles?.isAdmin}>
                                    <div className='p-3 rounded bg-light border-left border-warning shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.faFa?.calendarAlt} /> {labels?.registerDate?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold'>
                                            {setDateTimeFormatGlobal({
                                                date: modalObj?.requirement?.userRegisterDate,
                                                type: modalObj?.languageObj?.format?.date?.f1,
                                                format: 0,
                                                addTime: false,
                                                subMethod: 'detailsRegisterDate',
                                            })?.result || '---'}
                                        </span>
                                    </div>
                                </div>
                                <div className='col-md-6 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-success shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.faFa?.calendarAlt} /> {labels?.visitDate?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold'>
                                            {setDateTimeFormatGlobal({
                                                date: modalObj?.requirement?.visitDate,
                                                type: modalObj?.languageObj?.format?.date?.f1,
                                                format: 0,
                                                addTime: false,
                                                subMethod: 'detailsVisitDate',
                                            })?.result || '---'}
                                        </span>
                                    </div>
                                </div>
                                <div className='col-md-6 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-dark shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.userShield} /> {labels?.authorizedBy?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold'>{modalObj?.requirement?.authorizedBy || '---'}</span>
                                    </div>
                                </div>
                                <div className='col-md-6 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.userTag} /> {labels?.contactPerson?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold'>{modalObj?.requirement?.contactPerson || '---'}</span>
                                    </div>
                                </div>
                                <div className='col-md-12 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.building} /> {labels?.department?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold'>{modalObj?.requirement?.department || '---'}</span>
                                    </div>
                                </div>
                                <div className='col-md-12 mb-4'>
                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                        <i className={icons?.fasFa?.edit} /> {labels?.commentary?.[modalObj?.languageObj?.id]}
                                    </small>
                                    <div className='p-3 rounded bg-white border-left border-secondary shadow-sm' style={{ minHeight: '100px', fontSize: '0.95rem', lineHeight: '1.6', overflowWrap: 'break-word', borderLeftWidth: '5px' }}>
                                        {modalObj?.requirement?.commentary || '---'}
                                    </div>
                                </div>
                                <div className='col-md-12 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-dark shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.infoCircle} /> {labels?.informCreation?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold'>
                                            {modalObj?.requirement?.informCreation ? labels?.yes?.[modalObj?.languageObj?.id] : labels?.no?.[modalObj?.languageObj?.id]}
                                        </span>
                                    </div>
                                </div>
                                {modalObj?.requirement?.informCreation && modalObj?.requirement?.informCreationUserId && (
                                    <div className='col-md-12 mb-4'>
                                        <div className='p-3 rounded bg-light border-left border-success shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                            <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                                <i className={icons?.fasFa?.userPlus} /> {labels?.informCreationUser?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <span className='h6 mb-0 font-weight-bold'>
                                                {(() => {
                                                    const user = users.find(u => u.id === modalObj?.requirement?.informCreationUserId);
                                                    return user ? `${user.firstName}, ${user.lastName}` : '---';
                                                })()}
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.defaultClass}
                            style={{ borderRadius: '5px' }}
                            disabled={process?.save}
                            hidden={modalObj?.type === 2}
                            tooltip='tooltip'
                            title={modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                            type='submit'>
                            {process?.save ? (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            ) : (
                                <i id={controls?.icons?.save?.id} className={`${controls?.icons?.save?.defaultClass} mr-2`} />
                            )}
                            {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.defaultClass}
                            style={{ borderRadius: '5px' }}
                            disabled={process?.save}
                            tooltip='tooltip'
                            title={labels?.close?.[modalObj?.languageObj?.id]}
                            type='button'
                            onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.back?.id })}>
                            <i id={controls?.icons?.back?.id} className={`${controls?.icons?.back?.defaultClass} mr-2`}></i>
                            {labels?.back?.[modalObj?.languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    );
}